const {hasOpenedParentWindow} = require('od-modules/utils/tab_manager/tab_status');
const logger = require('od-modules/utils/logger');
const COMMUNICATE_TABS = 'message';
const ERROR_CONTEXT = 'Proxy Tabs should have window context and ID to be named';
const ERROR_MESSAGE_WITH_DATA = 'postMessage triggered with data should have {event} property';
const hasInValidContext = (context, idContext) => !(context instanceof Window) || !idContext;
const hasInvalidMessage = (data) => Odigeo._.isObject(data) && !data.event;

class ProxyTabs {
    constructor(context, idContext) {
        if (hasInValidContext(context, idContext)) {
            logger.message(ERROR_CONTEXT);
            return;
        }
        this.context = context;
        this.proxyEvents = [];
        this._activateCrossDomainMessage(idContext);
    }

    _activateCrossDomainMessage(idContext) {
        this.context.name = `${idContext}`;
    }

    _validateCommunication({data, origin}, event) {
        const parsedData = Odigeo.Utils.parseJson(data) || {};
        return origin === window.location.origin && (data === event || parsedData.event === event);
    }

    setProxyEvents(handlerEvents = {}) {
        for (const [event, handler] of Object.entries(handlerEvents)) {
            this.proxyEvents.push({
                event: `${COMMUNICATE_TABS}.${event}`,
                handler: (message) => {
                    if (this._validateCommunication(message.originalEvent, event)) {
                        handler(message);
                    }
                },
            });
        }
        return this;
    }

    _getProxyEvents() {
        return this.proxyEvents.map(({event}) => event).join(' ');
    }

    bindHandlers() {
        $(this.context).off(this._getProxyEvents());
        this.proxyEvents.map(({event, handler}) => $(this.context).on(event, handler));
    }

    static closeCrossDomainMessage() {
        window.opener = null;
        $(window).off(COMMUNICATE_TABS);
    }

    /*
    * @param {string} data - 'event_name' (to subscribe handlers in a new ProxyTabs())
    * @param {object} data - {event: 'event_name', ...data_to_send_to_other_window}
    */
    static trigger(data) {
        if (window.postMessage && hasOpenedParentWindow()) {
            if (hasInvalidMessage(data)) {
                logger.message(ERROR_MESSAGE_WITH_DATA);
                return;
            }
            if (Odigeo._.isObject(data)) data = JSON.stringify(data);
            window.opener.parent.postMessage(data, window.location.origin);
        }
    }
}

module.exports = {
    ProxyTabs,
    ERROR_CONTEXT,
    ERROR_MESSAGE_WITH_DATA,
};
